import { useCallback } from 'react';

export function useBlobDownload() {
  return useCallback((data, name) => {
    const urlObject = URL.createObjectURL(data);

    const a = document.createElement('a');
    a.href = urlObject;
    a.download = name;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(urlObject);
  }, []);
}
